/**
 * Format date components to yyyy-MM-dd string (UTC-safe)
 */
const formatDateToYYYYMMDD = (year: number, month: number, day: number): string => {
  const y = String(year);
  const m = String(month).padStart(2, '0');
  const d = String(day).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const convertExcelDate = (value: string | number | Date | undefined): string | undefined => {
  if (!value || (typeof value === 'string' && value.trim() === '')) {
    return undefined;
  }

  if (value instanceof Date && !isNaN(value.getTime())) {
    return formatDateToYYYYMMDD(value.getUTCFullYear(), value.getUTCMonth() + 1, value.getUTCDate());
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  // Handle dd/MM/yyyy format
  const ddmmyyyy = typeof value === 'string' ? value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/) : null;
  if (ddmmyyyy) {
    const [_, d, m, y] = ddmmyyyy;
    return formatDateToYYYYMMDD(parseInt(y), parseInt(m), parseInt(d));
  }

  const serial = typeof value === 'number' ? value : parseFloat(String(value));
  if (!isNaN(serial)) {
    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
    const dateObj = new Date(excelEpoch.getTime() + Math.floor(serial + 1e-5) * 24 * 60 * 60 * 1000);
    return formatDateToYYYYMMDD(dateObj.getUTCFullYear(), dateObj.getUTCMonth() + 1, dateObj.getUTCDate());
  }

  return undefined;
};

export const parseBoolean = (value: string | number | undefined, defaultValue = false): boolean => {
  if (value === undefined || value === null || String(value).trim() === '') {
    return defaultValue;
  }

  const normalized = String(value).toLowerCase().trim();
  const truthyValues = ['true', '1'];
  const falsyValues = ['false', '0'];

  if (truthyValues.includes(normalized)) return true;
  if (falsyValues.includes(normalized)) return false;

  return defaultValue;
};

export const parseNumber = (value: any, defaultValue = 0, precision = 2): number => {
  if (value === undefined || value === null || String(value).trim() === '') {
    return defaultValue;
  }
  const parsed = parseFloat(String(value));
  if (Number.isNaN(parsed)) return defaultValue;
  const factor = Math.pow(10, precision);
  return Math.round(parsed * factor) / factor;
};

export const excelSerialToDate = (serial: number): string => {
  const excelEpoch = new Date(Date.UTC(1899, 11, 30));
  const days = Math.floor(serial);
  const date = new Date(excelEpoch.getTime() + days * 24 * 60 * 60 * 1000);

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
};

export const isDateCell = (cellObj: any): boolean => {
  if (!cellObj) return false;
  if (cellObj.t === 'd') return true;
  if (cellObj.t === 'n' && cellObj.w && /\d{1,2}\/\d{1,2}\/\d{2,4}/.test(cellObj.w)) {
    return true;
  }
  return false;
};
